import React from 'react'
import MediaQuery from 'react-responsive'

import { AcornsIcon } from '@acorns/icons'
import { Spinner } from '@acorns/web-components'
import styled from 'styled-components'

import withdrawLogo from 'assets/images/withdraw-zero-balance.png'
import useWindowDimensions from 'hooks/useWindowDimensions'
import themeValues, { style } from 'theme'
import { USDFormatter } from 'utils/number/currency'

import {
  RedStyledCloseAccountButton,
  StyledBody,
  StyledCard,
  StyledImage,
} from '../components'
import { MergedProps } from './index'

const WVCard = styled(StyledCard)<{ innerHeight?: number }>`
  display: flex;
  justify-content: space-between;
  height: ${(props) => `calc(${props.innerHeight}px - 80px)`};
  &&& {
    border-radius: 0;
  }
`

const BodyContainer = styled.div`
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    height: auto;
    padding-top: 50px;
  }
  @media screen and (max-width: 375px) {
    padding-top: 10px;
  }
`

const ProcessingWithdrawls = styled.div`
  max-width: 500px;
  min-width: 400px;
  margin: 0 auto;
  border: 1px solid ${style((theme) => theme.colors.ivory)};
  border-radius: ${style((theme) => theme.styles.borderRadius)};
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    min-width: 200px;
    max-width: 90%;
  }
`

const Item = styled.div`
  min-width: 100%;
  padding: 18px 20px;
  align-items: center;
  justify-content: space-between;
  display: flex;
`

const Product = styled.span`
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0px;
  line-height: 24px;
  color: ${style((theme) => theme.colors.slate)};
  display: inline-block;
  margin-left: 12px;
`

const Amount = styled.span`
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 24px;
  text-align: right;
  color: ${style((theme) => theme.colors.slate)};
  float: right;
`
const WrappingDiv = styled.div`
  display: inline-block;
  align-items: center;
`

const ButtonContainer = styled.div`
  border-top: 1px solid ${style((theme) => theme.colors.ivory)};
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    border-top: none;
    position: relative;
    width: 100%;
  }
`

const Footnote = styled.div`
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 16px;
  text-align: center;
  margin-bottom: 50px;
  margin-top: 30px;
  color: ${style((theme) => theme.colors.stone)};
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    margin-top: 0;
    margin-bottom: 20px;
    padding-top: 20px;
  }
`

export const CloseWithBalanceConfirmation: React.FC<MergedProps> = ({
  handleShowConfirmationModal,
  finalTransferAccount,
  spendBalance,
  isWebView,
}) => {
  const CardComponent = isWebView ? WVCard : StyledCard
  const { height } = useWindowDimensions()
  return (
    <>
      <CardComponent innerHeight={isWebView ? height : null}>
        <BodyContainer>
          <StyledImage src={withdrawLogo} />

          <StyledBody>
            Your money will be transferred to your <b>{finalTransferAccount}</b>{' '}
            account, then we’ll automatically close your Spend account.
          </StyledBody>
          <ProcessingWithdrawls>
            <Item>
              <WrappingDiv>
                <AcornsIcon
                  icon={AcornsIcon.Icon.Spend}
                  width="24px"
                  style={{ float: 'left' }}
                />
                <Product>Spend</Product>
              </WrappingDiv>

              <WrappingDiv>
                {spendBalance !== undefined ? (
                  <Amount data-testid="spend_balance">
                    {USDFormatter.format(spendBalance)}
                  </Amount>
                ) : (
                  <Spinner height={20} width={20} />
                )}
              </WrappingDiv>
            </Item>
          </ProcessingWithdrawls>
          <MediaQuery minWidth={themeValues.breakpoints.sm}>
            <Footnote>
              Transfers may take up to 3-6 business days to settle.
            </Footnote>
          </MediaQuery>
        </BodyContainer>
        <ButtonContainer>
          <MediaQuery maxWidth={themeValues.breakpoints.sm - 1}>
            <Footnote>
              Transfers may take up to 3-6 business days to settle.
            </Footnote>
          </MediaQuery>
          <RedStyledCloseAccountButton onClick={handleShowConfirmationModal}>
            Close account
          </RedStyledCloseAccountButton>
        </ButtonContainer>
      </CardComponent>
    </>
  )
}
